import LayerTile from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS.js';
import WMSCapabilities from 'ol/format/WMSCapabilities.js';

// Parsel en üstte, ardından ürün, ardından Eylül Yeşil. Diğer katmanlar 0.
const wmsStackRank = (layerName) => {
  const name = (layerName || '').toLowerCase();
  if (name.includes('parsel')) return 30;
  if (name.includes('urun')) return 20;
  if (name.includes('eylul') && name.includes('yesil')) return 10;
  return 0;
};

const wmsZIndex = (stackRank) => {
  if (stackRank >= 30) return 5;
  if (stackRank >= 20) return 4;
  if (stackRank >= 10) return 3;
  return 1;
};

export const getWMSCapabilities = async (
  username,
  password,
  getCapabilitiesURL,
  wmsURL
) => {
  const headers = new Headers();
  headers.set('Authorization', 'Basic ' + btoa(`${username}:${password}`));

  const tileLoadFunction = (imageTile, src) => {
    const headers = new Headers();
    headers.set('Authorization', 'Basic ' + btoa(`${username}:${password}`));

    const init = {
      method: 'GET',
      headers: headers,
      mode: 'cors',
      cache: 'default',
    };

    fetch(src, init)
      .then((response) => response.blob())
      .then((blob) => {
        const imageUrl = URL.createObjectURL(blob);
        imageTile.getImage().src = imageUrl;
      })
      .catch((error) => {
        console.error('Tile loading failed:', error);
      });
  };

  try {
    const response = await fetch(getCapabilitiesURL, { headers });
    const data = await response.text();
    const parser = new WMSCapabilities();
    const result = parser.read(data);
    const layers = result.Capability.Layer.Layer;

    const wmsLayers = [];
    for (let i = 0; i < layers.length; i++) {
      const layer = layers[i];
      const layerName = layer.Name;
      // Panel listeyi ters çevirir; yüksek sıra dizinin sonuna gider ve
      // panelde üstte görünür. zIndex aynı sırayı haritada da tutar.
      // Sorgu vurguları 10-20 aralığında kaldığı için WMS değerleri düşüktür.
      const stackRank = wmsStackRank(layerName);

      const wmsLayer = new LayerTile({
        title:
          layerName.split(':')[1].charAt(0).toUpperCase() +
          layerName.split(':')[1].slice(1),
        extent: layer.BoundingBox[1].extent,
        zIndex: wmsZIndex(stackRank),
        source: new TileWMS({
          url: wmsURL,
          params: {
            LAYERS: layerName,
            TILED: true,
          },
          serverType: 'geoserver',
          crossOrigin: 'anonymous',
          tileLoadFunction: tileLoadFunction,
        }),
      });
      wmsLayers.push(wmsLayer);
    }

    // Artan öncelik: il/ilçe/raster altta, sonra Eylül Yeşil, Ürün, Parsel.
    wmsLayers.sort(
      (a, b) => wmsStackRank(a.get('title')) - wmsStackRank(b.get('title'))
    );

    return wmsLayers;
  } catch (error) {
    console.error('GetCapabilities loading failed:', error);
    return [];
  }
};

/*
getWMSCapabilities(username, password, url).then((wmsLayers) => {
  console.log(wmsLayers);
});
*/
